import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { sstyled as _sstyled } from 'intergalactic/utils/lib/core/index';
import { assignProps as _assignProps2 } from 'intergalactic/core';
import { assignProps as _assignProps } from 'intergalactic/core';
var _excluded = ["Children", "forwardRef", "modifiers", "stretch"];
import React from 'react';
import createComponent, { Root, Component, sstyled } from 'intergalactic/core';
import Popper, { isInputTriggerTag } from 'intergalactic/popper';
import capitalizeFirstLetter from 'intergalactic/utils/lib/capitalizeFirstLetter';
import uniqueIDEnhancement from 'intergalactic/utils/lib/uniqueID';
import i18nEnhance from 'intergalactic/utils/lib/enhances/i18nEnhance';
import { localizedMessages } from './translations/__intergalactic-dynamic-locales';
/*__reshadow-styles__:"./style/dropdown.shadow.css"*/
var style = ( /*__reshadow_css_start__*/_sstyled.insert( /*__inner_css_start__*/".___SDropdownPopper_14b3o_gg_{position:relative;background-color:var(--intergalactic-bg-primary-neutral, #ffffff);border-radius:var(--intergalactic-popper-rounded, 6px);box-sizing:border-box;border:1px solid var(--intergalactic-border-secondary, #e0e1e9);white-space:normal;box-shadow:var(--intergalactic-box-shadow-popper, 0px 1px 12px 0px rgba(25, 27, 35, 0.15));color:var(--intergalactic-text-primary, #191b23)}" /*__inner_css_end__*/, "14b3o_gg_") /*__reshadow_css_end__*/, {
  "__SDropdownPopper": "___SDropdownPopper_14b3o_gg_"
});
import { hasFocusableIn } from 'intergalactic/utils/lib/use/useFocusLock';
import keyboardFocusEnhance from 'intergalactic/utils/lib/enhances/keyboardFocusEnhance';
var INTERACTION_TAGS = ['INPUT', 'TEXTAREA'];
var Dropdown = /*#__PURE__*/function (_Component) {
  _inherits(Dropdown, _Component);
  var _super = _createSuper(Dropdown);
  function Dropdown() {
    var _this;
    _classCallCheck(this, Dropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "popperRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "defaultModifiers", [{
      name: 'flip',
      enabled: false
    }, {
      name: 'stretch',
      phase: 'beforeRead',
      enabled: true,
      fn: function fn(_ref5) {
        var state = _ref5.state,
          options = _ref5.options;
        var _state$placement$spli = state.placement.split('-'),
          _state$placement$spli2 = _slicedToArray(_state$placement$spli, 1),
          position = _state$placement$spli2[0];
        var isVertical = ['left', 'right'].indexOf(position) !== -1;
        var len = isVertical ? 'height' : 'width';
        var referenceLen = state.elements.reference["offset".concat(capitalizeFirstLetter(len))];
        if (options.stretch === 'min') {
          state.rects.popper.width = Math.max(state.rects.popper.width, referenceLen);
          state.elements.popper.style["min".concat(capitalizeFirstLetter(len))] = "".concat(referenceLen, "px");
        }
        if (options.stretch === 'fixed') {
          state.rects.popper.width = referenceLen;
          state.elements.popper.style[len] = "".concat(referenceLen, "px");
        }
      }
    }]);
    _defineProperty(_assertThisInitialized(_this), "handlerTriggerKeyDown", function (e) {
      var _this$asProps = _this.asProps,
        visible = _this$asProps.visible,
        interaction = _this$asProps.interaction;
      var element = _this.popperRef.current;
      if (interaction === 'click' && visible && e.key === 'Tab' && element && !hasFocusableIn(element)) {
        e.preventDefault();
        return;
      }
      if (e.key === ' ' && INTERACTION_TAGS.includes(e.target.tagName)) return;
      if (e.key === 'Enter' && e.target.tagName === 'TEXTAREA') return;
      if (['Enter', ' '].includes(e.key) && interaction !== 'none') {
        e.preventDefault();
        _this.handlers.visible(true);
      }
    });
    return _this;
  }
  _createClass(Dropdown, [{
    key: "uncontrolledProps",
    value: function uncontrolledProps() {
      return {
        visible: null
      };
    }
  }, {
    key: "getTriggerProps",
    value: function getTriggerProps() {
      var _this$asProps2 = this.asProps,
        uid = _this$asProps2.uid,
        visible = _this$asProps2.visible,
        disablePortal = _this$asProps2.disablePortal,
        getI18nText = _this$asProps2.getI18nText;
      return {
        id: "igc-".concat(uid, "-trigger"),
        'aria-controls': visible ? "igc-".concat(uid, "-popper") : undefined,
        focusHint: visible && !disablePortal ? getI18nText('triggerHint') : undefined,
        'aria-expanded': visible ? 'true' : 'false',
        onKeyDown: this.handlerTriggerKeyDown
      };
    }
  }, {
    key: "getPopperProps",
    value: function getPopperProps() {
      var _this$asProps3 = this.asProps,
        uid = _this$asProps3.uid,
        disablePortal = _this$asProps3.disablePortal,
        ignorePortalsStacking = _this$asProps3.ignorePortalsStacking,
        interaction = _this$asProps3.interaction;
      return {
        id: "igc-".concat(uid, "-popper"),
        tabIndex: 0,
        role: 'dialog',
        disablePortal: disablePortal,
        ignorePortalsStacking: ignorePortalsStacking,
        ref: this.popperRef,
        focusMaster: interaction === 'click',
        autoFocus: 'enforced'
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$asProps4 = this.asProps,
        Children = _this$asProps4.Children,
        forwardRef = _this$asProps4.forwardRef,
        _this$asProps4$modifi = _this$asProps4.modifiers,
        modifiers = _this$asProps4$modifi === void 0 ? [] : _this$asProps4$modifi,
        stretch = _this$asProps4.stretch,
        other = _objectWithoutProperties(_this$asProps4, _excluded);
      return /*#__PURE__*/React.createElement(Popper, _extends({
        ref: forwardRef,
        modifiers: [].concat(_toConsumableArray(this.defaultModifiers), [{
          name: 'stretch',
          options: _typeof(stretch) === 'object' ? stretch : {
            stretch: stretch
          }
        }], _toConsumableArray(modifiers))
      }, other), /*#__PURE__*/React.createElement(Children, null));
    }
  }]);
  return Dropdown;
}(Component);
_defineProperty(Dropdown, "displayName", 'Dropdown');
_defineProperty(Dropdown, "style", style);
_defineProperty(Dropdown, "defaultProps", {
  // timeout: [100, 50],
  placement: 'bottom-start',
  offset: [0, 4],
  stretch: 'min',
  defaultVisible: false,
  i18n: localizedMessages,
  locale: 'en',
  interaction: 'click'
});
_defineProperty(Dropdown, "enhance", [uniqueIDEnhancement(), i18nEnhance(localizedMessages)]);
function DropdownTrigger(_ref6) {
  var _ref = arguments[0],
    _ref3;
  var styles = _ref6.styles,
    Tag = _ref6.tag;
  var hasInputTrigger = isInputTriggerTag(Tag);
  var SDropdownTrigger = Popper.Trigger;
  return _ref3 = sstyled(styles), /*#__PURE__*/React.createElement(SDropdownTrigger, _ref3.cn("SDropdownTrigger", _objectSpread({}, _assignProps({
    "role": hasInputTrigger ? 'combobox' : 'button'
  }, _ref))));
}
function DropdownPopper(_ref7) {
  var _ref2 = arguments[0],
    _ref4;
  var styles = _ref7.styles;
  var SDropdownPopper = Popper.Popper;
  return _ref4 = sstyled(styles), /*#__PURE__*/React.createElement(SDropdownPopper, _ref4.cn("SDropdownPopper", _objectSpread({}, _assignProps2({}, _ref2))));
}
export default createComponent(Dropdown, {
  Trigger: DropdownTrigger,
  Popper: DropdownPopper
}, {
  parent: Popper
});
//# sourceMappingURL=Dropdown.js.map